import { ChangelogEntry } from '@infodata-group/inf-commons';
import { ChangelogVisibilityTypes } from '../type/changelog-visibility.types';
import dayjs from 'dayjs';
import { DtoWebtoolsChangelogEntryInterface } from '../interface/dto-webtools-changelog-entry.interface';

export class WebtoolsChangelogEntry extends ChangelogEntry {
  product: string;
  version: string;
  versionId: string;
  createdBy: string;
  updatedBy: string;
  updatedAt: Date;
  public visibility: ChangelogVisibilityTypes;

  public override serialize(): DtoWebtoolsChangelogEntryInterface {
    return {
      id: this.getId(),
      product: this.product,
      versionId: this.versionId,
      date: dayjs(this.date).format('DD/MM/YYYY - HH:mm'),
      createdBy: this.createdBy,
      updatedAt: this.updatedAt
        ? dayjs(this.updatedAt).format('DD/MM/YYYY - HH:mm')
        : null,
      updatedBy: this.updatedBy,
      title: this.title,
      message: this.message,
      type: this.type,
      visibility: this.visibility,
    };
  }
}
